import apiCall from "../apiService";
import { AUTH_ROUTES } from "../../utils/constants/apiRoute";
/**
 * Updates a product by ID using the centralized API call utility.
 *
 * @param {string} id - Product ID
 * @param {Object} product
 * @param {string} product.prodName
 * @param {string|number} product.prodPrice
 * @param {string} product.prodCategoryId
 * @param {string} product.prodCategoryName
 * @param {string|number} product.quantity
 * @returns {Promise<Object>}
 *
 * @author Susovan Mishra
 */

const updateProduct = async (id, product) => {
  const formData = new FormData();
  formData.append("prodName", product.prodName);
  formData.append("prodPrice", Number(product.prodPrice));
  // Ensure we always send a plain category ObjectId string, not a full object
  const rawCategory = product.prodCategoryId;
  const prodCategoryId =
    typeof rawCategory === "string"
      ? rawCategory
      : rawCategory?._id || rawCategory?.id || "";

  formData.append("prodCategoryId", prodCategoryId);
  formData.append("prodCategoryName", product.prodCategoryName);
  formData.append("quantity", Number(product.quantity));
  formData.append("description", product.description || "");
  formData.append("veg", Boolean(product.veg));
  
  // Handle image - either file or imageUrl, but not both
  if (product.file) {
    formData.append("file", product.file);
  } else {
    formData.append("imageUrl", product.imageUrl || "");
  }
  return await apiCall(`${AUTH_ROUTES.PRODUCTS_API_ENDPOINT}/${id}`, {
    method: "PUT",
    body: formData,
  });
};

export default updateProduct;
